import { render, staticRenderFns } from "./contacts-messenger.vue?vue&type=template&id=0e9ac7c5&scoped=true&"
import script from "./contacts-messenger.vue?vue&type=script&lang=js&"
export * from "./contacts-messenger.vue?vue&type=script&lang=js&"
import style0 from "./contacts-messenger.vue?vue&type=style&index=0&id=0e9ac7c5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9ac7c5",
  null
  
)

export default component.exports